import { render, staticRenderFns } from "./AdminReviewTable.vue?vue&type=template&id=722ce50f&scoped=true"
import script from "./AdminReviewTable.vue?vue&type=script&lang=js"
export * from "./AdminReviewTable.vue?vue&type=script&lang=js"
import style0 from "./AdminReviewTable.vue?vue&type=style&index=0&id=722ce50f&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ce50f",
  null
  
)

export default component.exports